import { Controller } from "stimulus";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import LazyLoad from "vanilla-lazyload";


export default class extends Controller {
    static targets = ["body", "info", "pwaBanner"];

    connect() {
        this.IEdetect();

        this.lazyImages();

        if (this.IOSdetect() && !this.isInStandaloneMode()) {
            this.ckBannerPwa = "ckbnrpwa";

            if (document.cookie.indexOf(this.ckBannerPwa) >= 0) {
                this.pwaBannerTarget.remove();
            } else {
                setTimeout(() => { this.openPwaBannerIOS(); }, 500);

                var lastScrollTop = 0;
                window.addEventListener("scroll", () => {
                    var st = window.pageYOffset || document.documentElement.scrollTop;
                    if (st > lastScrollTop) this.closePwaBannerIOS();
                    else this.openPwaBannerIOS();
                    lastScrollTop = st <= 0 ? 0 : st;
                }, false);
            }
        }
    }

    IEdetect() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            document.documentElement.classList.add('ie');
        }

        return false;
    }

    bodyNoScroll() {
        disableBodyScroll(this.bodyTarget);
    }

    bodyScroll() {
        enableBodyScroll(this.bodyTarget);
    }

    lazyImages() {
        this.ll = new LazyLoad({
            class_loaded: "is-loaded",
            class_error: "is-error",
        });
    }

    openInfo() {
        this.infoTarget.classList.add("is-open");
        this.bodyNoScroll();
    }

    closeInfo() {
        this.infoTarget.classList.remove("is-open");
        this.bodyScroll();
    }

    /*
        Browser Back Button
     */

    goBack(e) {
        e.preventDefault();
        if (window.history.length > 1) {
            window.history.back();
        } else {
            var localePermalink = "/";
            if (window.location.href.indexOf('&locale=') > -1) {
                localePermalink = window.location.href.split("&locale=")[1];
            }
            window.location.href = localePermalink;
        }
    }

    IOSdetect() {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    }

    isInStandaloneMode() {
        return ('standalone' in window.navigator) && (window.navigator.standalone);
    }

    openPwaBannerIOS() {
        this.pwaBannerTarget.classList.add("is-open");
    }

    closePwaBannerIOS() {
        this.pwaBannerTarget.classList.remove("is-open");
    }

    removePwaBannerIOSAndSetCookie() {
        document.cookie = this.setCookie(this.ckBannerPwa, "1", 365);
        this.pwaBannerTarget.remove();
    }

    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        window.location.href = window.location.href;
    }
}

